var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDryCleaninginline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M32 11a3 3 0 1 0-3-3m3 3v3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 14h10"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M38.364 12.757 32 19.121l3.121 3.122 6.364-6.364z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M41 16c6.333 0 9.167 2.667 9.5 8q.5 8 1.5 28h-8"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M44 29v30H32m-6.364-46.243L32 19.121l-3.121 3.122-6.364-6.364z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M23 16c-6.333 0-9.167 2.667-9.5 8Q13 32 12 52h8"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M20 29v30h12m0-39v39"
}))));
export default SvgDryCleaninginline;